import {
  Component,
  OnInit,
  Injector,
  Output,
  EventEmitter,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { ClienteService } from "../../services/cliente.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import swal from "sweetalert2";
import * as moment from "moment";
import { AlertService } from "../../services/alert.service";
import { CommonFunctions } from "../../utils/common-functions";
import { NgxPermissionsService, NgxRolesService } from "ngx-permissions";
import { ModalTipoProductoComponent } from "../../components/modal-tipo-producto/modal-tipo-producto.component";
import {ProfileService} from '../../components/seguridad-creacion-perfil/profile.service';
import { RoleService } from '../../components/seguridad-creacion-rol/role.service';
import { AuthService } from '../../services/auth.service';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
@Component({
  selector: "app-gestiones",
  templateUrl: "./gestiones.component.html",
  styleUrls: ["./gestiones.component.scss"],
})
export class GestionesComponent implements OnInit {
  segmento: string;
  listABF = [];
  precalificaiones = [];
  politicas: null;
  term: string;
  sircRuta12 = "activosCanceladosReserva";
  sircRuta15 = "endeudaCancelados";
  participante = 0;
  gestionSeleccionada = null;
  token: string;
  currentUser = localStorage.getItem("currentUser");
  codigoEmpleado = localStorage.getItem("codigoEmpleado");
  reverse = false;
  order = "noPrecalificacion";
  tabselected = 1;
  error1002Flag = false //cliente con credito aprobado que debe extornar
  datacliente;
  dataCodeudor;
  segmentoSelected;
  dataProductoCliente;
  clienteserviceParam;
  dpi = "";
  refreshPrecas = true; // actualiza las precalificaciones
  public habilitado = 0;
  formContainerWidth = 570;
  flowType = "";
  statusLoadPrecasAB=false // flag de carga de precaciones de AB
  constructor(
    private http: HttpClient,
    private activateRoute: ActivatedRoute,
    private clienteservice: ClienteService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private ngxRoleService: NgxRolesService,
    private ngxPermissionService: NgxPermissionsService,
    private router: Router,
    private alertService: AlertService,
    public dialog: MatDialog,
    private profileService: ProfileService,
    private roleService: RoleService,
    private authService: AuthService
  ) {
    this.clienteserviceParam = clienteservice;
    if (this.activateRoute.snapshot.paramMap.get("segmento") != null) {
      this.segmentoSelected =
        this.activateRoute.snapshot.paramMap.get("segmento");
    }
    this.activateRoute.queryParams.subscribe(params=>{
      if (params['token'] != null) {
         setTimeout(() => {
           this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
           this.clienteservice.validateTokenAB(params['token']).then(result => {
             this.loginAB(result.nickUser)
           }).catch(error => {
             this.denyAccessAB();
           })
         }, 1000);
       }
    })
  }

  ngOnInit(): void {
    localStorage.setItem("iniciaPreca", "");
    this.token = localStorage.getItem("token");
  }
  changeSegmento(segmento) {
    this.segmentoSelected = segmento
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  getColor(tipoOferta) {
    switch (tipoOferta) {
      case "V":
        return "#00bd9a";
      case "A":
        return "#cfa000";
      case "R":
        return "#ac1949";
    }
  }
  loginAB(user) {
    this.profileService.getUserProfile({
      usuario: user.trim().toLowerCase(),
    }).then(profile => {
      if (profile && profile.codigo === 1) {
        if (profile.Respuesta.length > 0) {
          const userProfile = profile.Respuesta[0];
          if (userProfile.estado_rol && userProfile.estado_usuario) {
            if (userProfile.id_rol && userProfile.nombre_rol) {
              // El ingreso por token es exclusivo del rol Agente Bancario.
              if (!this.authService.canLoginWithToken(userProfile.nombre_rol)) {
                this.denyAccessAB();
                return;
              }
              this.roleService.getPermissionsByRole(userProfile.id_rol).then(data => {
                this.statusLoadPrecasAB=true
                if (data && data.codigo === 1) {
                  const permissions = data.Respuesta;

                  if (permissions.length > 0) {
                    const ngxPermissions = this.authService.startSession(
                      userProfile.nombre_rol,
                      userProfile.id_rol,
                      permissions,
                      'AB'
                    );
                    if (ngxPermissions.length > 0) {
                      this.clienteservice.rolABFlag=true
                    } else {
                      this.denyAccessAB();
                    }
                  } else {
                    this.denyAccessAB();
                  }
                } else {
                  this.denyAccessAB();
                }
              }).catch(error => {
                this.denyAccessAB();
              });
            } else {
              this.denyAccessAB();
            }
          } else {
            this.denyAccessAB();
          }
        } else {
          this.denyAccessAB();
        }
      } else {
        this.denyAccessAB();
      }
    }).catch(error => {
      this.denyAccessAB();
    })
  }
  denyAccessAB() {
    this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
    this.authService.clearSession();
    this.router.navigate(['errorpath']);
    if (window.top) {
      window.top.close();
    }
  }
  async selectgestion(Gestion) {
    try {
      this.participante = 0;
      this.gestionSeleccionada = [];
      this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
      const precalificacion = await this.clienteservice.getPrecalificacion(
        Gestion.noPrecalificacion
      );
      this.selecttab(1);
      this.gestionSeleccionada = precalificacion;

      this.politicas =
        this.gestionSeleccionada.ofertaComercialSeleccionada.politica;
      if (
        this.gestionSeleccionada.estadoProceso === "OFERTA_SELECCIONADA" &&
        this.gestionSeleccionada.estadoColorPrecalificacion === "VERDE"
      ) {
        const datos = await this.clienteservice.integracionBancaBT(
          precalificacion.noPrecalificacion,
          precalificacion.tipoProducto
        );
        if (precalificacion.tipoProducto == '000') {
          if (datos.codigoError === "0") {
            this.gestionSeleccionada.estadoProceso = "INTEGRADA_BT";
          } else {
            this.gestionSeleccionada.estadoProceso = "OFERTA_SELECCIONADA";
            this.gestionSeleccionada.mensajeProceso = datos.mensajeTecnicoAPI;
          }
        } else if (precalificacion.tipoProducto == '004') {
          if (datos.error.codigoError === "0") {
            this.gestionSeleccionada.estadoProceso = "INTEGRADA_BT";
          } else {
            this.gestionSeleccionada.estadoProceso = "OFERTA_SELECCIONADA";
            this.gestionSeleccionada.mensajeProceso = datos.error.mensajeTecnicoAPI;
          }
        }
      }
      const datacliente = await this.clienteservice.getInfoCliente(
        this.gestionSeleccionada.participante[0].datosGenerales.dpi
      );
      this.clienteservice.datosCliente = {};
      this.datacliente = datacliente;
      this.clienteservice.datosCliente = this.datacliente;
      if (this.gestionSeleccionada.participante.length > 1) {
        const data = await this.clienteservice.getInfoCliente(
          this.gestionSeleccionada.participante[1].datosGenerales.dpi
        );
        this.clienteservice.datosCodeudor = {};
        this.dataCodeudor = data;
        this.clienteservice.datosCodeudor = this.dataCodeudor;
      }
      await this.clearTarjetasBuroInterno();
      this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
    } catch (e) {
      console.log(e);
      this.gestionSeleccionada = null;
      this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
      this.showNotification(
        "Ha ocurrido un error",
        "Por favor inténtelo mas tarde."
      );
    }
  }

  clearTarjetasBuroInterno() {
    const tarjetas = [];
    this.gestionSeleccionada.participante[
      this.participante
    ].buroInterno.tarjetas.forEach((element) => {
      if (tarjetas.find((i) => i.noTarjeta == element.noTarjeta) != null) {
        const aux = tarjetas.find((i) => i.noTarjeta == element.noTarjeta);
        if (aux.limiteCredito < element.limiteCredito) {
          aux.limiteCredito = element.limiteCredito;
        }
        aux.pagoMinimo = Number(aux.pagoMinimo) + Number(element.pagoMinimo);
        aux.saldo = Number(aux.saldo) + Number(element.saldo);
      } else {
        tarjetas.push(element);
      }
    });
    this.gestionSeleccionada.participante[
      this.participante
    ].buroInterno.tarjetas = tarjetas;
  }

  async selectParticipante(numeroparticipante) {
    try {
      this.participante = numeroparticipante;
      const datacliente = await this.clienteservice.getInfoCliente(
        this.gestionSeleccionada.participante[numeroparticipante].datosGenerales
          .dpi
      );
      this.datacliente = datacliente;
    } catch (e) {
      this.showNotification(
        "Ha ocurrido un error",
        "Por favor inténtelo mas tarde."
      );
    }
  }
  async consultaCliente(dpi) {
    this.clienteservice = new ClienteService(
      this.http,
      this.ngxRoleService,
      this.ngxPermissionService
    );
    this.clienteservice.datosCliente.isNewExistClient = false;
    this.clienteservice.flowType='DEBTOR'
    this.clienteserviceParam = this.clienteservice;
    this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
    this.clienteservice
      .getInfoCliente(dpi)
      .then((dataCliente) => {
        this.datacliente = dataCliente;
        if (
          dataCliente &&
          dataCliente.error &&
          dataCliente.error.codigoError === "999999"
        ) {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.showNotification(
            "Ha ocurrido un error",
            "El DPI ingresado es inválido"
          );
          return;
        } else if (
          dataCliente &&
          dataCliente.error &&
          dataCliente.error.codigoError === "90"
        ) {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.showNotification(
            "Ha ocurrido un error",
            dataCliente.error.mensajeTecnicoAPI
          );
          return;
        }
        else if (
          dataCliente.cliente.tipoClasificacionCliente === "CN" &&
          dataCliente.cliente.nombreCompleto === null
        ) {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.showNotification(
            "Alerta",
            'El dpi ingresado no corresponde a un cliente existente'
          );
        } else {
          this.clienteservice.datosCliente = this.datacliente;
          const clientData = this.clienteservice.datosCliente;
          this.clienteservice
            .ConsultaProducoCliente(this.datacliente.cliente)
            .then((dataproductos) => {
              this.ngxUiLoaderService.stopLoader(
                "loader-global",
                "loadingDashboard"
              );
              this.dataProductoCliente = dataproductos;
              this.clienteservice.consultaFlag = true
              if (
                dataCliente &&
                dataCliente.error &&
                dataCliente.error.codigoError === "1002"
              ) {
                this.showAlertConsultaCliente(
                  "Aviso",
                  dataCliente.error.mensajeTecnicoAPI.split(":")[1].trim()
                );
              }
              else {
                this.selecttab(14);
              }
              //this.validateSIRC(this.dataProductoCliente);
            })
            .catch((error) => {
              this.ngxUiLoaderService.stopLoader(
                "loader-global",
                "loadingDashboard"
              );
              // tslint:disable-next-line:max-line-length
              if (error.internoBantrab.creditos !=null||error.internoBantrab.tarjetas!=null) {
                this.dataProductoCliente = error;
                this.clienteservice.productosCliente=error
                this.clienteservice.consultaFlag = true
                if (
                  dataCliente &&
                  dataCliente.error &&
                  dataCliente.error.codigoError === "1002"
                ) {
                  this.showAlertConsultaCliente(
                    "Aviso",
                    dataCliente.error.mensajeTecnicoAPI.split(":")[1].trim()
                  );
                }
                else {
                  this.selecttab(14);
                }
              } else {
                this.showNotification(
                  "Ha ocurrido un error",
                  "En este momento no contamos con conexión al buro externo (SIB) inténtelo de nuevo en unos minutos."
                );
                this.selectedtab(0);
              }
            }); 
        }
      })
      .catch((error) => {
        this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
        this.showNotification(
          "Ha ocurrido un error",
          "Por favor inténtelo mas tarde."
        );
      });
  }
  async setDataCliente(data) {
    this.dpi = "";
    if (data.flowType === "DEBTOR") {
      this.clienteservice = new ClienteService(
        this.http,
        this.ngxRoleService,
        this.ngxPermissionService,
      );
      this.clienteservice.datosCliente.isNewExistClient = false;
    } else {
      this.clienteservice.datosCodeudor.isNewExistClient = false;
    }
    this.clienteservice.consultaFlag=false
    this.clienteservice.flowType = data.flowType;
    this.clienteservice.tipoPrecalificacion = data.tipopreca

    this.clienteserviceParam = this.clienteservice;
    this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
    this.clienteservice
      .getInfoCliente(data.dpi)
      .then((dataCliente) => {
        dataCliente.needCoDebtor = false;
        this.datacliente = dataCliente;
        if (
          dataCliente &&
          dataCliente.error &&
          dataCliente.error.codigoError === "999999"
        ) {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.showNotification(
            "Ha ocurrido un error",
            "El DPI ingresado es inválido"
          );
          return;
        } else if (
          dataCliente &&
          dataCliente.error &&
          dataCliente.error.codigoError === "90"
        ) {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.showNotification(
            "Aviso",
            dataCliente.error.mensajeTecnicoAPI
          );
          return;
        } else if (
          dataCliente &&
          dataCliente.error &&
          dataCliente.error.codigoError === "1002"
        ) {
          this.error1002Flag = true
        }
        if (data.flowType === "DEBTOR") {
          this.clienteservice.datosCliente = this.datacliente;
        } else {
          this.clienteservice.datosCodeudor = this.datacliente;
        }

        const clientData =
          data.flowType === "DEBTOR"
            ? this.clienteservice.datosCliente
            : this.clienteservice.datosCodeudor;
        if (
          clientData.cliente.tipoClasificacionCliente === "CN" &&
          clientData.cliente.nombreCompleto === null
        ) {
          this.clienteservice.datosCliente.ut = true;
          if (data.flowType === "DEBTOR") {
            this.clienteservice.datosCliente.isNewExistClient = true;
          } else {
            this.clienteservice.datosCodeudor.isNewExistClient = true;
          }
          this.dpi = data.dpi;
          this.showNitAlert();
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
        } else {
          this.clienteservice
            .ConsultaProducoCliente(this.datacliente.cliente)
            .then((dataproductos) => {
              this.dataProductoCliente = dataproductos;
              if (data.flowType === "DEBTOR") {
                this.validateSIRC(this.dataProductoCliente);
              } else {
                const response =
                  CommonFunctions.validateIndirectCreditsCoDebtor(
                    this.clienteservice.productosCliente.internoBantrab,
                    this.clienteservice.productosCodeudor.internoBantrab,
                    this.clienteservice.datosPorductosClientes
                  );
                if (response.canCoDebtor === true) {
                  if (
                    response.commonCredits.length > 0 &&
                    !response.isCommonCreditConsolidated
                  ) {
                    this.ngxUiLoaderService.stopLoader(
                      "loader-global",
                      "loadingDashboard"
                    );
                    this.alertService
                      .confirmationHMTL(
                        `<strong>Nota:</strong>`,
                        `<span>Se detecto que el codeudor comparte un producto en común con el deudor, el cual se tendrá que consolidar al finalizar el registro del mismo ¿Desea continuar con el codeudor?</span><br>`,
                        "Continuar"
                      )
                      .then((confirm) => {
                        if (confirm.isConfirmed) {
                          this.selecttab(14)
                        } else {
                          this.forceFinishCodebtorFlow()
                        }
                      });
                  }
                  this.validateSIRC(this.dataProductoCliente);
                } else {
                  this.ngxUiLoaderService.stopLoader(
                    "loader-global",
                    "loadingDashboard"
                  );
                  this.alertService
                    .confirmationHMTL(
                      `<strong>Nota:</strong>`,
                      `<span>El codeudor ingresado es codeudor de otro crédito. Puede agregar otro a continuación.</span><br>`,
                      "Continuar"
                    )
                    .then((confirm) => {
                      if (confirm.isConfirmed) {
                        this.clienteserviceParam.datosPrecalificacionCodeudor =
                          {};
                        this.clienteserviceParam.commonCredits = [];
                        this.showDpiAlert();
                      } else {
                        
                      }
                    });
                }
              }
            })
            .catch((error) => {
              this.ngxUiLoaderService.stopLoader(
                "loader-global",
                "loadingDashboard"
              );
              // tslint:disable-next-line:max-line-length
              if (error.error!=null &&error.error.codigoError!=null&&error.error.codigoError == "88") {
                this.showNotification(
                  "Aviso",
                  error.error.mensajeTecnicoAPI
                );
              } else {
                this.showNotification(
                  "Aviso",
                  "En este momento no contamos con conexión al buro externo (SIB) inténtelo de nuevo en unos minutos."
                );
              }
              this.selectedtab(0);
            });
        }
      })
      .catch((error) => {
        this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
        this.showNotification(
          "Ha ocurrido un error",
          "Por favor inténtelo mas tarde."
        );
      });
  }
  forceFinishCodebtorFlow() {
    if(this.clienteserviceParam.datosPrecalificacion.segmento!='PV'){
      this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
      this.clienteserviceParam.commonCredits = [];
      this.clienteserviceParam.datosPrecalificacionCodeudor = {};
      this.clienteserviceParam.rejectCoDebtorFlow().then(() => {
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
        this.selecttab(11);
      });
    } else {
      this.clienteserviceParam.rejectCoDebtorFlow()
      this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
        this.clienteserviceParam
        .solicitarOferta()
        .then((result) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.clienteserviceParam.datosCliente.needCoDebtor = false;
          if (result == "SD") {
            this.showNotification(
              "No se han obtenido ofertas",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          } else if (result == "A") {
            if (this.clienteserviceParam.ofertasComerciales.ofertaComercial.length == 2 && this.clienteserviceParam.ofertasComerciales.ofertaComercial[0].bienestarMixAndMatchFlg==1) {
              this.clienteserviceParam.ofertaseleccionada = 0
              this.clienteserviceParam.ofertamym=0
              this.selecttab(13)
            } else {
              this.selecttab(12);
            }
          } else {
            this.showNotification(
              "Ha ocurrido un error",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          }
        })
        .catch((error) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          if (error.codigoError && error.codigoError == "1003") {
            this.showNotification(
              "Aviso",
              error.mensajeTecnicoAPI
            );
          }
          else if (error.codigoError!="0") {
            this.showNotification(
              "Aviso",
              'Ha ocurrido un error, intentelo más tarde. Código de error: '+error.codigoError
            );
          }
          else if (error == "errorguardado") {
            this.showNotification(
              "Ha ocurrido un error",
              "No se ha podido guardar la precalificación."
            );
          } else{
            this.showNotification(
              "Alerta",
              "No se ha podido establecer conexión con el servidor, intentelo de nuevo."
            );
          }
        });

    }
  }
  validacionNit(nit) {
    const clientData =
      this.clienteservice.flowType === "DEBTOR"
        ? this.clienteservice.datosCliente
        : this.clienteservice.datosCodeudor;
    clientData.cliente.errorSatFlag=false
    this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
    let nitvalido = true;
    clientData.cliente.nit = this.clienteserviceParam.getCleanedString(nit);
    if (nit === "") {
      this.showNotification(
        "Alerta",
        "Para poder continuar debe de ingresar un NIT."
      );
      nitvalido = false;
      this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
    }
    if (nitvalido === true) {
      this.clienteservice
        .consultaClienteSAT(clientData.cliente.nit)
        .then((datos) => {
          if (datos.error && datos.error.codigoError === "0") {
            let dpi = datos.dpi;
            let name = datos.nombre;

            if (dpi != null || name != null) {
              dpi = dpi.trim();
              name = name.split(",");
              const firstName = name[3];
              const lastName = name[0];
              if (dpi) {
                if (dpi.length !== 13) {
                  this.ngxUiLoaderService.stopLoader(
                    "loader-global",
                    "loadingDashboard"
                  );
                  this.showNotification(
                    "Alerta",
                    "El nit ingresado no es correcto"
                  );
                  return;
                } else {
                  clientData.cliente.dpi = datos.dpi;
                }

                if (this.dpi !== dpi) {
                  this.ngxUiLoaderService.stopLoader(
                    "loader-global",
                    "loadingDashboard"
                  );
                  this.showNotification(
                    "Alerta",
                    "El nit ingresado no pertenece al cliente."
                  );
                  return;
                }
              } else {
                if (
                  firstName.trim() !==
                    this.clienteserviceParam.datosCliente.cliente.primerNombre.trim() &&
                  lastName.trim() !==
                    this.clienteserviceParam.datosCliente.cliente.primerApellido.trim()
                ) {
                  this.ngxUiLoaderService.stopLoader(
                    "loader-global",
                    "loadingDashboard"
                  );
                  this.showNotification(
                    "Alerta",
                    "El nit ingresado no pertenece al cliente."
                  );
                  return;
                }
              }
            } else {
              this.ngxUiLoaderService.stopLoader(
                "loader-global",
                "loadingDashboard"
              );
              this.showNotification(
                "Alerta",
                "El nit ingresado no es correcto"
              );
              return;
            }

            clientData.cliente.nombreCompleto =
              name[3] + " " + name[4] + " " + name[0] + " " + name[1];
            clientData.cliente.primerNombre = name[3];
            clientData.cliente.segundoNombre = name[4];
            clientData.cliente.primerApellido = name[0];
            clientData.cliente.segundoApellido = name[1];
            // this.calculoEdad(this.CustomerFechaNacimiento, 1);
            clientData.cliente.fechaNacimiento = datos.fechaNacimiento;
            clientData.cliente.codigoClienteBantrab = "0";
            clientData.cliente.existeEmpleadoGobierno = "";
            clientData.cliente.casadaApellido = "";
            this.ngxUiLoaderService.stopLoader(
              "loader-global",
              "loadingDashboard"
            );
            this.selectTipoProducto()
          } else {
            this.ngxUiLoaderService.stopLoader(
                  "loader-global",
                  "loadingDashboard"
                );
            clientData.cliente.dpi = this.dpi
            clientData.cliente.codigoClienteBantrab = "0";
            clientData.cliente.existeEmpleadoGobierno = "";
            clientData.cliente.casadaApellido = "";
            clientData.cliente.segundoNombre = ""
            clientData.cliente.segundoApellido = ""

            clientData.cliente.errorSatFlag=true
            this.showAlertSatError()
            // if (datos.error.codigoError === "60") {
            //   this.ngxUiLoaderService.stopLoader(
            //     "loader-global",
            //     "loadingDashboard"
            //   );
            //   this.showNotification(
            //     "Alerta",
            //     "Ha ocurrido un error, Compruebe que el NIT este correcto."
            //   );
            //   return;
            // } else {
            //   this.ngxUiLoaderService.stopLoader(
            //     "loader-global",
            //     "loadingDashboard"
            //   );
            //   this.showNotification(
            //     "Alerta",
            //     "Ha ocurrido un error al solicitar información."
            //   );
            //   return;
            // }
          }
        })
        .catch((error) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          clientData.cliente.dpi = this.dpi
          clientData.cliente.codigoClienteBantrab = "0";
          clientData.cliente.existeEmpleadoGobierno = "";
          clientData.cliente.casadaApellido = "";
          clientData.cliente.segundoNombre = ""
          clientData.cliente.segundoApellido = ""

          clientData.cliente.errorSatFlag=true
          this.showAlertSatError()
        });
    }
  }
  selecttab(tab) {
    if (tab == '0') {
      this.segmentoSelected = ''
    }
    this.tabselected = tab;
  }
  showNotification(title, message) {
    swal
      .fire({
        title,
        html: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }
  showAlertConsultaCliente(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
        this.selecttab(14);
      });
  }
  refreshPrecalificaciones(param) {
    this.refreshPrecas = !param;
  }
  showNitAlert() {
    this.selectedtab(0);
    this.OpenClose();
    const nit = "";
    swal
      .fire({
        title: "Ingrese el Nit del cliente",
        input: "text",
        inputLabel: "NIT",
        inputValue: nit,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        inputValidator: (result) =>
          !result && "Por favor ingrese el número de NIT.",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        confirmButtonText: "Continuar",
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.validacionNit(result.value);
        } else {
          this.OpenClose();
        }
      });
  }
  showAlertSatError() {
    this.selectedtab(0);
    this.OpenClose();
    swal
      .fire({
        title:'Aviso',
        text: 'No se ha podido realizar la consulta en la SAT, ¿Desea ingresar los datos manualmente?',
        confirmButtonColor: '#fff',
        background: '#eeedf2',
        customClass: {
          confirmButton: 'btn button-precas',
          denyButton: 'btn button-precas',
          input: 'inputswt',
          title: 'titleswt'
        },
        showDenyButton: true,
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        denyButtonText: 'No',
        confirmButtonText: 'Si',
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.selectTipoProducto()
        } else {
          this.OpenClose();
        }
      });
  }

  showDpiAlert() {
    const dpi = "";
    swal
      .fire({
        title: "Ingrese el DPI del codeudor",
        input: "text",
        inputLabel: "DPI",
        inputValue: dpi,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        showCloseButton: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        heightAuto: false,
        inputValidator: (result) =>
          (!result && "Por favor ingrese un número de DPI.") ||
          (result.length !== 13 &&
            "El número de DPI no es válido, favor verifique.") ||
          (result === this.clienteserviceParam.datosCliente.cliente.dpi &&
            "El número de DPI ingresado no puede ser igual al de deudor"),
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        confirmButtonText: "Continuar",
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.clienteserviceParam.commonCredits = [];
          this.clienteserviceParam.datosPrecalificacionCodeudor = {};
          this.ngxUiLoaderService.startLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.setDataCliente({
            dpi: result.value,
            flowType: "CODEBTOR",
          }).then();
        }
      });
  }

  selectedtab(tab) {
    this.selecttab(tab);
  }
  OpenClose() {
    this.habilitado = this.habilitado === 1 ? 0 : 1;
    this.habilitado === 1
      ? (this.formContainerWidth = 500)
      : (this.formContainerWidth = 0);
  }

  validateSIRC(data: any): void {
    const clientData =
      this.clienteservice.flowType === "DEBTOR"
        ? this.clienteservice.datosCliente
        : this.clienteservice.datosCodeudor;
    const internal = data.internoBantrab;
    const external = data.sircRuta12;
    const searchWay = data.rutaBusqueda;
    const internalNit =
      clientData.cliente.nit && clientData.cliente.nit !== ""
        ? CommonFunctions.getNitWithUnderscore(clientData.cliente.nit)
        : "";
    const externalNit =
      external && external.mensaje && external.mensaje.contenido
        ? external.mensaje.contenido.infgral.nit
        : "";

    // case 1
    if (
      external === null &&
      (internal.creditos !== null || internal.tarjetas !== null)
    ) {
      let credits = internal.creditos !== null ? internal.creditos : [];
      let cards = internal.tarjetas !== null ? internal.tarjetas : [];
      let differenceMonth = 0;
      const currentDate = moment();

      if (credits.length > 1) {
        credits = credits.reverse();
      }

      if (cards.length > 1) {
        cards = cards.reverse();
      }

      const lastCredit = credits.length > 0 ? credits[0] : null;
      const lastCard = cards.length > 0 ? cards[0] : null;

      if (lastCredit && lastCard) {
        const cardDate = moment(lastCard.fechaConsesion, "DD/MM/YYYY");
        const diffDaysCard = currentDate.diff(cardDate, "days");
        const creditDate = moment(lastCredit.fConsecion, "DD/MM/YYYY");
        const diffDaysCredit = currentDate.diff(creditDate, "days");
        if (diffDaysCard < diffDaysCredit) {
          differenceMonth = currentDate.diff(cardDate, "months");
        } else {
          differenceMonth = currentDate.diff(creditDate, "months");
        }
      } else if (lastCredit && !lastCard) {
        const creditDate = moment(lastCredit.fConsecion, "DD/MM/YYYY");
        differenceMonth = currentDate.diff(creditDate, "months");
      } else if (lastCard && !lastCredit) {
        const cardDate = moment(lastCard.fechaConsesion, "DD/MM/YYYY");
        differenceMonth = currentDate.diff(cardDate, "months");
      } else {
        this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
        this.showNotification(
          "Nota",
          "Ha ocurrido un error, intente de nuevo en unos minutos"
        );
        this.selecttab(0);
        return;
      }

      if (differenceMonth > 1) {
        this.ngxUiLoaderService.stopLoader("loader-global", "loadingDashboard");
        this.showNotification(
          "Nota",
          "Hubo una inconsistencia en la respuesta de la SIRC, no se puede finalizar el proceso, " +
            "favor avocarse con su Centro de Procesamiento"
        );
        this.selecttab(0);
        return;
      } else {
          this.selectTipoProducto() 
      }
    }else{
        this.selectTipoProducto() 
    }
  }
  selectTipoProducto() {
    this.ngxUiLoaderService.stopLoader(
      "loader-global",
      "loadingDashboard"
    );
    if (this.clienteservice.flowType == "DEBTOR") {
      if (this.clienteservice.tipoPrecalificacion == 'credito_fiduciario' && this.error1002Flag) {
        this.showNotification(
          "Aviso",
          this.datacliente.error.mensajeTecnicoAPI.split(":")[1].trim()
        );
      } else {
        this.selecttab(14)
      }
    } else {
      this.selecttab(14)
    }
  }
  showDpiAndProductModal(params) {
    if (params.pageOrigin == 'detalleEvaluacion') {
      this.setDataCliente({
        dpi: params.dpi,
        tipopreca: 'credito_fiduciario',
        flowType: "DEBTOR",
      })
    } else {
      const dialogRef = this.dialog.open(ModalTipoProductoComponent, {
        width: "380px",
        height: "auto",
        data: {
          permisoCredito: this.ngxPermissionService.getPermission('evaluacionCredito') != null ? true : false,
          permisoTC: this.ngxPermissionService.getPermission('evaluacionTarjeta') != null ? true : false,
          permisoMixto: this.ngxPermissionService.getPermission('evaluacionCreditoMixto') != null ? true : false,
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.setDataCliente(result)
      })
    }
  }
}
